import UserPhoneNumberFormLayout from '../Layout';
import UserPhoneNumberFormLayoutRenderer from '../Layout/Renderer';
import { UserPhoneNumberFormRendererProps } from './props';

/**
 * UserPhoneNumberFormRenderer is a functional component that renders a form layout for user phone numbers.
 *
 * @param {boolean} useMinimalForm - Determines if the minimal form layout should be used.
 * @param {boolean} isKycFlow - Indicates if the form is part of the KYC (Know Your Customer) flow.
 * @param {boolean} isContainerColor - Determines if the container should have a specific color.
 *
 * @returns {JSX.Element} - Returns a JSX element that represents the form layout.
 *
 * Example usage:
 * <UserPhoneNumberFormRenderer
 *   useMinimalForm={true}
 *   isKycFlow={false}
 *   isContainerColor={true}
 * />
 */
export default function UserPhoneNumberFormRenderer({
  useMinimalForm,
  isKycFlow,
  isContainerColor,
}: UserPhoneNumberFormRendererProps): JSX.Element {
  if (useMinimalForm) {
    return (
      <UserPhoneNumberFormLayoutRenderer
        isKycFlow={isKycFlow}
        isContainerColor={isContainerColor}
      />
    );
  }

  return (
    <UserPhoneNumberFormLayout>
      <UserPhoneNumberFormLayoutRenderer
        isKycFlow={isKycFlow}
        isContainerColor={isContainerColor}
      />
    </UserPhoneNumberFormLayout>
  );
}
